import { render, staticRenderFns } from "./EmailVerificationRequest.vue?vue&type=template&id=9faba99a&"
import script from "./EmailVerificationRequest.vue?vue&type=script&lang=ts&"
export * from "./EmailVerificationRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports